export { default as axios } from './axiosInstance';

export const handleError = (error) => {
  if (error.response) {
    console.error(error.message);
    console.error('data ->', error.response.data);
  } else if (error.request) {
    console.error('Request Failed! ->', error.message);
  } else {
    console.error(error.message);
  }
};

export const createFormData = (data) => {
  const formData = new FormData();

  Object.keys(data).map((key) => {
    formData.append(key, data[key]);
  });

  return formData;
};
